import React from 'react';
import { CreditCard } from 'lucide-react';
import { Label } from '../ui/label';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';

const PaymentOptionsSection = ({ paymentOption, setPaymentOption, priceBreakdown }) => {
  if (!priceBreakdown) return null;

  return (
    <div className="space-y-4">
      <div className="border-t border-zinc-800 pt-6">
        <h3 className="text-white font-semibold text-lg mb-4 flex items-center">
          <CreditCard className="w-5 h-5 mr-2" />
          Payment Options
        </h3>
        
        <RadioGroup value={paymentOption} onValueChange={setPaymentOption} className="space-y-3">
          <div className="flex items-center space-x-3 p-4 rounded-lg border-2 border-zinc-700 hover:border-red-500/50 bg-zinc-900 transition-all cursor-pointer">
            <RadioGroupItem value="full" id="full" />
            <Label htmlFor="full" className="flex-1 cursor-pointer">
              <div className="text-white font-semibold">Pay Full Amount Now</div>
              <div className="text-gray-400 text-sm">
                Pay ${priceBreakdown.total.toFixed(2)} now and you're all set
              </div>
            </Label>
          </div>
          
          <div className="flex items-center space-x-3 p-4 rounded-lg border-2 border-zinc-700 hover:border-red-500/50 bg-zinc-900 transition-all cursor-pointer">
            <RadioGroupItem value="pay-later" id="pay-later" />
            <Label htmlFor="pay-later" className="flex-1 cursor-pointer">
              <div className="text-white font-semibold">Pay After Service</div>
              <div className="text-gray-400 text-sm">
                Book now, pay ${priceBreakdown.total.toFixed(2)} after service completion
              </div>
            </Label>
          </div>
        </RadioGroup>
      </div>
    </div>
  );
};

export default PaymentOptionsSection;
